import { Box, Typography } from '@mui/material';
import React, { useState, type MouseEvent } from 'react';
import DelimitedLabels, { VerticalSeparator } from '../../common/components/DelimitedLabels';
import EllipsisText from '../../common/components/EllipsisText';
import { PUNCTUATION_MARKS_CONSTANTS } from '../../common/constants/constants';
import { H } from '../../common/Layout';
import ResponsiveLayout from '../../common/ResponsiveLayout';
import { hyperlinkSx } from '../../common/utils/commonUtils';
import type { RolePeopleMap } from '../types';
import { OWNER_ITEM_WRAPPER_SX, OWNER_RESPONSIVE_LAYOUT_SX, OWNER_TILE_WIDTH } from './projectOwnerConstants';

const ownerRoleGroupSx = { gap: 0.5, alignItems: 'center', minWidth: 0, maxWidth: '100%', overflow: 'hidden' };
const ownerRoleLabelSx = { whiteSpace: 'nowrap' };

type RenderPeopleByRoleProps = {
    peopleGroupedByRole: RolePeopleMap[];
    onPersonClick?: (event: MouseEvent<HTMLButtonElement>, personId?: string) => void;
};

function RenderPeopleByRole({ peopleGroupedByRole, onPersonClick }: RenderPeopleByRoleProps) {
    const [lastVisibleIndex, setLastVisibleIndex] = useState<number | undefined>();

    return (
        <ResponsiveLayout
            gap={1.5}
            sx={OWNER_RESPONSIVE_LAYOUT_SX}
            tileWidth={OWNER_TILE_WIDTH}
            setLastElementToFitIndex={setLastVisibleIndex}
        >
            {peopleGroupedByRole.map((roleGroup, index) => {
                const { role, people } = roleGroup;

                const lastVisible = lastVisibleIndex ?? peopleGroupedByRole.length - 1;
                const showSeparator = index < peopleGroupedByRole.length - 1 && index < lastVisible;

                return (
                    <Box key={index} sx={OWNER_ITEM_WRAPPER_SX}>
                        <H sx={ownerRoleGroupSx}>
                            <Typography sx={ownerRoleLabelSx}>
                                {`${role}${PUNCTUATION_MARKS_CONSTANTS.colon}`}
                            </Typography>
                            <DelimitedLabels>
                                {people.map((p) => (
                                    <EllipsisText
                                        key={p.id}
                                        sx={p.id ? hyperlinkSx : undefined}
                                        onClick={(event: MouseEvent<HTMLButtonElement>) => onPersonClick?.(event, p.id)}
                                        text={p.name}
                                    />
                                ))}
                            </DelimitedLabels>
                        </H>
                        {showSeparator && <VerticalSeparator />}
                    </Box>
                );
            })}
        </ResponsiveLayout>
    );
}

export default RenderPeopleByRole;
